export const useSidebarSorter = async (page_post_url, tag_id, show_sidebar) => {

	const { env } = useRuntimeConfig().public;
	const sidebarStore = useSidebarStore();

	// BEST SCREENERS PAGES CANT HAVE THE 'best-screeners' in the URL, if not, this is going to retur null
	const best_screeers = [
		"/whats-a-stock-screener/",
		"/best-stock-screeners/",
		"/what-is-the-best-free-stock-screener/",
		"/stock-screener-and-fundamental/",
		"/stock-screener-for-day-trading/",
		"/stock-screener-with-technical-indicators/",
		"/stock-screener-for-swing-trading/",
		"/best-stock-screener-criteria/",
		"/live-stock-screener-free/",
		"/best-stock-screener-query/",
		"/stock-screener-growth/",
		"/stock-screener-dividend/",
		"/stock-screener-for-undervalued-stocks/",
		"/option-stock-screener/",
		"/stock-screener-value/",
		"/stock-screener-low-float/",
		"/stock-screener-penny-stocks/",
		"/otc-stock-screener/",
		"/premarket-stock-screener/",
		"/stock-screener-5-year-performance/",
		"/stock-screener-volatility/",
		"/stock-screener-for-chart-patterns/",
		"/after-hours-stock-screener/",
		"/stock-screener-by-volume/",
		"/best-screeners/whats-a-stock-screener/",
		"/best-screeners/best-stock-screeners/",
		"/best-screeners/what-is-the-best-free-stock-screener/",
		"/best-screeners/stock-screener-and-fundamental/",
		"/best-screeners/stock-screener-for-day-trading/",
		"/best-screeners/stock-screener-with-technical-indicators/",
		"/best-screeners/stock-screener-for-swing-trading/",
		"/best-screeners/best-stock-screener-criteria/",
		"/best-screeners/live-stock-screener-free/",
		"/best-screeners/best-stock-screener-query/",
		"/best-screeners/stock-screener-growth/",
		"/best-screeners/stock-screener-dividend/",
		"/best-screeners/stock-screener-for-undervalued-stocks/",
		"/best-screeners/option-stock-screener/",
		"/best-screeners/stock-screener-value/",
		"/best-screeners/stock-screener-low-float/",
		"/best-screeners/stock-screener-penny-stocks/",
		"/best-screeners/otc-stock-screener/",
		"/best-screeners/premarket-stock-screener/",
		"/best-screeners/stock-screener-5-year-performance/",
		"/best-screeners/stock-screener-volatility/",
		"/best-screeners/stock-screener-for-chart-patterns/",
		"/best-screeners/after-hours-stock-screener/",
		"/best-screeners/stock-screener-by-volume/",
	];

	const how_to = [
		"/how-to-buy-stocks/",
		"/how-to-buy-amzn-stock/",
		"/how-to-buy-tsla-stock/",
		"/how-to-buy-aapl-stock/",
		"/how-to-buy-meta-stock/",
		"/how-to-buy-googl-stock/",
		"/how-to-buy-wmt-stock/"
	];

	const checkIfPrintsSidebar = (url, tag, show_sidebar) => {
		if (show_sidebar === "best-screeners" || best_screeers.includes(url) || url.includes("best-screeners")) return "best-screeners";

		if (tag === 214) {
			return "how-buy-stocks";
		}

		// If item doesn't match any of the predefined values, return null or handle as needed
		return null;
	};

	const sidebarName = checkIfPrintsSidebar(page_post_url, tag_id, show_sidebar);

	if (!sidebarName) {

		if (sidebarStore.contentSidebar.show) sidebarStore.toggleContentSidebarVisibility(false);

		if (env !== 'production') {
			console.error("No matching sidebar ID found.");
		}
		return null;
	}

	try {

		if (sidebarStore.contentSidebar.sidebarName === sidebarName && sidebarStore.contentSidebar.data) {
			if (!sidebarStore.contentSidebar.show) sidebarStore.toggleContentSidebarVisibility(true);
			return
		};

		const sidebar = await fetch(`/js/menus/${sidebarName}.json`).then(res => {
			if (res.ok) {
				return res.json()
			}
		});

		if (sidebar) {
			const payload = [...sidebar];
			sidebarStore.toggleContentSidebarVisibility(true);
			sidebarStore.setContentSidebarData(payload);
			sidebarStore.setContentSidebarName(sidebarName);

			return { sidebar: payload, sidebarName };
		}
		console.error("Fetch returned no data.");
	} catch (error) {
		console.error("Error fetching data:", error);
	}
	return null;
};
